const ONE_DAY_IN_MS = 1 * 24 * 60 * 60 * 1000;
const DEFAULT_SESSION_INCREASE = 30 * 60 * 1000;

//Returns null if there is no cookie with that name, otherwise returns the cookie's value
const get = function(cookieName) {
	const reg = new RegExp(
		"(?:(?:^|.*;)\\s*" + cookieName + "\\s*\\=\\s*([^;]*).*$)|^.*$"
	);
	return (
		(global.document &&
			decodeURIComponent(document.cookie.replace(reg, "$1"))) ||
		null
	);
};

// Sets a cookie to the value specified. Duration is in milliseconds and
// defaults to one day or is the string "session". Returns the expiration
//set or null if the cookie is set to expire at the end of a session.
const set = function(name, value, duration = ONE_DAY_IN_MS) {
	let cookieVal = name + "=" + value + "; path=/;";
	let expiration = null;
	if (duration !== "session") {
		expiration = Date.now() + duration;
		const expDate = new Date(expiration).toUTCString();
		cookieVal += " expires=" + expDate + ";";
	}

	if (process.env.NODE_ENV === "production") {
		cookieVal += "secure;";
	}

	document.cookie = cookieVal;
	return expiration;
};

//Clears the token cookie by overwriting with an empty expired cookie
const clear = function(name) {
	document.cookie = name + "=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};

//Creates an update plugin for the vault used to access the cookie setting
const makeCookieForVault = function(vault) {
	return {
		get,
		set,
		clear,
		getToken: () => ({
			token: get("token"),
			tokenExpiration: get("tokenExpiration"),
		}),
		setToken: (token, duration) => {
			if (
				!duration ||
				!isFinite(duration) ||
				duration < DEFAULT_SESSION_INCREASE
			) {
				duration = DEFAULT_SESSION_INCREASE;
			}
			const expiration = set("token", token, duration);
			set("tokenExpiration", expiration, duration);
			return expiration;
		},
		clearToken: () => {
			clear("token");
			clear("tokenExpiration");
			return {
				token: "",
				tokenExpiration: "",
			};
		},
	};
};

module.exports = {
	get,
	set,
	clear,
	makeCookieForVault,
};
